export default __webpack_public_path__ + "static/media/cal2.8babef31.svg";